export default __webpack_public_path__ + "static/media/ferramenta-baixar-videos-img3.f1e94319.jpeg";